<template>
   <div class="card">
       <div class="card-body">
           <div id="editor">
               <froala
                       :name="tempName"
                       ref="editor"
                       tag="textarea" :config="froalaConfig" v-model="tempDescription">
               </froala>
           </div>
       </div>
   </div>
</template>

<script>
    export default {
        name: "project-description",

        props: {
            name: String,
            description: String,
            create: Boolean
        },
        data() {
            return {
                tempName: this.name ? this.name : 'description',
                tempDescription: this.description,
                froalaConfig: {
                    charCounterCount: false,
                    placeholderText: this.create ? 'Create description' : 'Edit description'
                }
            }
        }
    }
</script>

<style scoped>
    #editor > div > div.fr-wrapper > div:nth-child(1) {
        visibility: hidden;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/projects/ProjectDescription.vue